/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerDetailsBioModalLazy_seller = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsBioModal_seller">;
    readonly " $refType": "PdpSharedDealerDetailsBioModalLazy_seller";
};
export type PdpSharedDealerDetailsBioModalLazy_seller$data = PdpSharedDealerDetailsBioModalLazy_seller;
export type PdpSharedDealerDetailsBioModalLazy_seller$key = {
    readonly " $data"?: PdpSharedDealerDetailsBioModalLazy_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerDetailsBioModalLazy_seller">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDealerDetailsBioModalLazy_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsBioModal_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
(node as any).hash = '25e812ab7f981a7d66f81a23e8415151';
export default node;
